<template>
  <div>
    <dialog-edit2 :value="value" @input="$emit('input')" :makeFocus="false">
      <template v-slot:title> Выбор основания для оплаты </template>
      <v-card-text style="height: 70vh; overflow: auto" class="pa-0">
        <a-table-f-api
          ref="table"
          :api="url"
          :model="model"
          :useQuery="true"
          :defaults="{
            sort: { key: 'id', order: 'DESC' },
            filters: filter,
            paramName: 'documentParent',
          }"
          @click="clickRow"
        >
        </a-table-f-api>
      </v-card-text>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <v-btn @click="$emit('input')">Закрыть</v-btn>
      </template>
    </dialog-edit2>
  </div>
</template>

<script>
import { getAccess, genModel } from "@/components/mixings";

export default {
  components: {},
  mixins: [getAccess, genModel],
  props: {
    value: Boolean,
    object_id: Number,
    config: { type: Object, default: () => {} },
  },
  data() {
    return {
      filter1: { status: 2 },
      filter2: { status: 2, type: [1, 2] },
    };
  },
  computed: {
    model() {
      //console.log("get model doc", this.config);
      let fields = this.config.document.docFields.split(",") || [];
      let model = JSON.parse(JSON.stringify(this.$store.getters["config/get"].models[this.config.document.model]));
      model = this.getModelList(model, this.config.document?.modelListName || "list");
      model = model.filter(el => {
        return fields.includes(el.name);
      });
      model.forEach(m => {
        m.hidden = false;
      });
      return model;
    },
    url() {
      return this.config.document.api;
    },
    filter() {
      return this.config.document?.filter || {};
    },
  },
  created() {},
  watch: {
    value() {
      if (this.value) {
      }
    },
  },
  methods: {
    clickRow(d) {
      this.$emit("select", d.row);
      this.$emit("input");
    },
  },
};
</script>
